// ─────────────────────────────────────────────────────────────
// FathomVoyage — Shared Components
// Layout · KPICard · DataBanner · LoadingSkeleton · SparkLine · ComingSoon
// ─────────────────────────────────────────────────────────────

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar.jsx';
import ConsentBanner from './ConsentBanner.jsx';
import { useSoftLogin } from '../auth/useSoftLogin.js';
import SoftLoginModal from '../auth/SoftLoginModal.jsx';

// ═══════════════════════════════════════
// LAYOUT
// ═══════════════════════════════════════
export default function Layout({ children }) {
  const navigate = useNavigate();
  const { showModal, dismiss, triggerKind } = useSoftLogin();

  const footerBtnStyle = {
    background: 'none', border: 'none', cursor: 'pointer',
    color: '#475569', fontSize: 12,
    fontFamily: "var(--font-body, 'Figtree', sans-serif)",
    transition: 'color 0.15s',
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <main style={{ flex: 1, paddingTop: 60 }}>
        {children}
      </main>

      <footer style={{
        borderTop: '1px solid rgba(255,255,255,0.05)',
        padding: '14px clamp(14px,2.5vw,28px)',
        display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20,
        background: 'var(--navy)',
      }}>
        <button
          onClick={() => navigate('/privacy')}
          style={footerBtnStyle}
          onMouseEnter={e => e.currentTarget.style.color = '#94a3b8'}
          onMouseLeave={e => e.currentTarget.style.color = '#475569'}
        >
          Privacy Policy
        </button>
        <span style={{ color: '#1e2d44', fontSize: 12, userSelect: 'none' }}>·</span>
        <button
          onClick={() => navigate('/terms')}
          style={footerBtnStyle}
          onMouseEnter={e => e.currentTarget.style.color = '#94a3b8'}
          onMouseLeave={e => e.currentTarget.style.color = '#475569'}
        >
          Terms of Service
        </button>
      </footer>

      <ConsentBanner />
      {showModal && <SoftLoginModal onDismiss={dismiss} triggerKind={triggerKind} />}
    </div>
  );
}
